export enum ProductListInWorld {
  offers = 'offers',
  'best-sales' = 'best_sellers',
  'offers-for-you' = 'client_offers',
  'random-offers' = 'world_products',
  'super-offers' = 'super_offers',
  'gift-club' = 'gift_club',
  group = 'group',
  category = 'category',
}
